import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getIsInDefaultBreakpointMode, getShowHiddenElements } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
const BREAKPOINT_PREVIEW_CLASS = 'breakpoint-preview';
const DEFAULT_PREVIEW_CLASS = 'default-preview';
const SHOW_HIDDEN_CLASS = 'show-hidden';
function StyleBreakpointsMarker() {
  const isInDefaultBreakpointMode = useSelector(getIsInDefaultBreakpointMode);
  const showHiddenElements = useSelector(getShowHiddenElements);
  useEffect(() => {
    const classList = document.body.classList;
    classList.toggle(DEFAULT_PREVIEW_CLASS, isInDefaultBreakpointMode);
    classList.toggle(BREAKPOINT_PREVIEW_CLASS, !isInDefaultBreakpointMode);
  }, [isInDefaultBreakpointMode]);
  useEffect(() => {
    const classList = document.body.classList;
    classList.toggle(SHOW_HIDDEN_CLASS, showHiddenElements);
  }, [showHiddenElements]);
  return null;
}
export default StyleBreakpointsMarker;